const ADMISSIONS_EMAIL = 'admision@sanlorenzocr.com';

const FORM_URLS: Record<string, string> = {
  solicitarInformacion: `https://formsubmit.co/ajax/${ADMISSIONS_EMAIL}`,
  agendarVisita: `https://formsubmit.co/ajax/${ADMISSIONS_EMAIL}`,
  contacto: `https://formsubmit.co/ajax/${ADMISSIONS_EMAIL}`,
};

export function getFormUrl(name: string): string | undefined {
  return FORM_URLS[name];
}
